import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IMaritalState } from './marital.state';

export class MaritalSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly maritalState = (state: IRootState): IMaritalState => {
    return state.marital as IMaritalState;
  };

  static readonly model = createSelector(MaritalSelectors.maritalState, (marital: IMaritalState) => {
    return marital.model;
  });

  static readonly data = createSelector(MaritalSelectors.maritalState, (marital: IMaritalState) => {
    return marital.data;
  });
}
